export const CONTENT_PIECES = {
    REVENUE_PER_AGE: 'revenue-per-age',
    REVENUE_PER_EMPLOYEE: 'revenue-per-employee',
    GROWTH_RATE: 'growth-rate',
    REVENUE_PER_CAPITAL: 'revenue-per-capital',
    CAPITAL_EFFICIENCY: 'capital-efficiency'
}